import { useForm } from "react-hook-form";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import { useEffect } from "react";
import {IPrintPlacementDto, ITransferTypeDto} from "Apis/Models/IPrintDto";
import {useMutateTransferType} from "../../../Apis/TransferTypeApi";

interface IProps {
    transferType?: ITransferTypeDto;
    onSubmit?: (data: IPrintPlacementDto) => void;
}
const TransferTypeForm = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { control, handleSubmit, reset } = useForm<ITransferTypeDto>()
    const { mutateAsync, isLoading } = useMutateTransferType();
    
    useEffect(() => {
        if (props.transferType) {
            reset(props.transferType);
        }
    }, [reset, props.transferType])
    
    const onSubmit = async(data: ITransferTypeDto) => {
        await mutateAsync(data);
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default TransferTypeForm
